import { ScreenId } from "@/js/value-objects/screen-id";

const FormUtils = {
  install: Vue => {
    /**
     * @param {Boolean} disabled
     * @param counter
     * @param hasClearable disabledに関係なくclearableが不要な場合はfalseを指定
     * @param hint
     */
    Vue.prototype.$formControlProps = (
      disabled,
      counter = null,
      hasClearable = true,
      hint = null
    ) => {
      const props = {
        outlined: !disabled,
        disabled: disabled
      };
      if (counter) {
        Object.assign(props, {
          maxlength: counter
        });
        if (!disabled) {
          Object.assign(props, {
            counter: counter
          });
        }
      }
      if (hasClearable) {
        Object.assign(props, {
          clearable: !disabled
        });
      }
      if (hint !== null && !disabled) {
        Object.assign(props, {
          hint: hint,
          persistentHint: true
        });
      }
      return props;
    };

    Vue.prototype.$formTitle = (prefix, isDisabled, isNew, suffix = "") => {
      let type = "";
      if (isDisabled) {
        type = "詳細";
      } else if (isNew) {
        type = "登録";
      } else {
        type = "編集";
      }
      return `${prefix}の${type}${suffix}`;
    };

    Vue.prototype.$cancelButtonText = (isDisabled = false) => {
      if (isDisabled) {
        return "戻る";
      }
      return "キャンセル";
    };

    Vue.prototype.$editButtonText = (isDisabled = false) => {
      if (isDisabled) {
        return "参照";
      }
      return "編集";
    };

    Vue.prototype.$saveButtonText = (isNew = false) => {
      if (isNew) {
        return "登録";
      }
      return "更新";
    };

    Vue.prototype.$screenTitle = (
      readOnly,
      readAuthorityTitle,
      operationAuthorityTitle
    ) => {
      if (readOnly) {
        return ScreenId.getScreenTitle(readAuthorityTitle);
      }
      return ScreenId.getScreenTitle(operationAuthorityTitle);
    };
  }
};
export default FormUtils;
